import getEnvironment, { EnvironmentTypes } from '@zola-helpers/client/dist/es/util/environment';

export const recaptchaKey =
  getEnvironment() === EnvironmentTypes.PRODUCTION
    ? '6LeBo8MfAAAAANhJVyX-l6gqh9C99g97uCrxsxEy'
    : '6Lc-azsgAAAAADCZ1GQ8yJI4w5YkuWgnyO6L9nBC';
